import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecordView = _resolveComponent("RecordView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_RecordView, {
      class: "record",
      record: _ctx.record,
      operational: _ctx.isRecordOperational,
      onGoBegin: _ctx.goBegin,
      onGoBack: _ctx.goBack,
      onGoForward: _ctx.goForward,
      onGoEnd: _ctx.goEnd,
      onSelectMove: _ctx.selectMove,
      onSelectBranch: _ctx.selectBranch
    }, null, 8, ["record", "operational", "onGoBegin", "onGoBack", "onGoForward", "onGoEnd", "onSelectMove", "onSelectBranch"])
  ]))
}